import { FormControlLabel, Stack, Switch, TextField } from '@mui/material';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import { StatusChip } from '../../shared/components/StatusChip';
import type { User } from '../../core/types/data-models';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'email', headerName: 'Email', flex: 1, minWidth: 240 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 180 },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    renderCell: (p) => <StatusChip value={p.value as string} />,
  },
];

export function UsersPage() {
  return (
    <CrudPage<User>
      title="Users"
      icon={<GroupOutlinedIcon fontSize="inherit" />}
      iconColor="primary"
      entityName="User"
      description="Global user accounts. Memberships into tenants are managed elsewhere."
      cacheKey={['users']}
      service={resources.users}
      columns={columns}
      defaultValues={{ email: '', name: '', status: 'ACTIVE' }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField
            label="Email"
            type="email"
            required
            value={values.email ?? ''}
            onChange={(e) => setValues({ ...values, email: e.target.value })}
          />
          <TextField
            label="Name"
            value={values.name ?? ''}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
          />
          <FormControlLabel
            control={
              <Switch
                checked={(values.status ?? 'ACTIVE') === 'ACTIVE'}
                onChange={(_, checked) =>
                  setValues({ ...values, status: checked ? 'ACTIVE' : 'PENDING' })
                }
              />
            }
            label="Active"
          />
        </Stack>
      )}
    />
  );
}
